import { createActions } from 'redux-actions';

// eslint-disable-next-line import/no-cycle
import { divertProgress } from '../steps/actions';
import { showMainLoading, hideMainLoading } from '../main/actions';
import { selectWorkflowActiveStepLinkByRel } from '../../../selectors';
import registrationApi from '../../../api/registrationApi';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';
import { getMarketingTagsMapped } from '../../../utils/gtmUtils';

export const { updateErrorMessage } = createActions(
  actionTypes.UPDATE_ERROR_MESSAGE,
  getActionOptions(ACTION_PREFIX),
);

export function createLead({ firstName, lastName }, callback) {
  return async (dispatch, getState) => {
    const state = getState();
    const stepLink = selectWorkflowActiveStepLinkByRel(state, 'CaptureDirector');
    dispatch(showMainLoading('Saving your details...'));
    const marketingTagsMapped = await getMarketingTagsMapped();

    registrationApi
      .createLead(stepLink.href, {
        ...marketingTagsMapped,
        firstName,
        lastName,
      })
      .then(async (response) => {
        if (callback) {
          callback();
        }
        const { output } = response.data;
        const { isLeadCreated, isError } = output;

        if (!isError && isLeadCreated) {
          const successMessage =
            'Thank you for entering your details. We will call you shortly to complete your registration.';
          dispatch(
            divertProgress({
              isBlocked: false,
              isSuccess: true,
              message: successMessage,
            }),
          );
        } else {
          dispatch(updateErrorMessage('Something went wrong, Please try again later'));
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((_reason) => {
        if (callback) {
          callback();
        }
        dispatch(updateErrorMessage('Something went wrong while while saving your details'));
      })
      .finally(() => {
        dispatch(hideMainLoading());
      });
  };
}
